import './RecordingWaves.css'

export default function RecordingWaves() {
  return (
    <>
      <span
        aria-hidden="true"
        data-recording-wave
        className="recording-wave absolute size-40 origin-center rounded-full bg-lc-error-500"
      />
      <span
        aria-hidden="true"
        data-recording-wave
        className="recording-wave recording-wave--delayed absolute size-40 origin-center rounded-full bg-lc-error-500"
      />
    </>
  )
}
